import Classes from "./style/contactUs.module.css";
// import css
export default function Contact() {
  return (
    <section className={Classes.sectionContact} id="contact-us">
      <div className={Classes.contact}>
        <div className={Classes.container}>
          <div className="common-heading">
            <h2 className={Classes.contactHeading}>Contact Us</h2>
          </div>
        </div>
        <iframe
          title="contact us"
          style={{ padding: "1.5rem 1.5rem", border: "0" }}
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2738.1475113428028!2d87.99787228775757!3d22.673394861747347!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xad171e4ad1519f6!2zTWFoYXByYWJodSBmdXJuaXR1cmUgKOCmruCmueCmvuCmquCnjeCmsOCmreCngSDgpqvgpr7gprDgp43gpqjgpr_gpprgpr7gprAp!5e0!3m2!1sen!2sin!4v1667241319339!5m2!1sen!2sin"
          width="100%"
          height="600"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
        <div className={`${Classes.sectionContactMain} contact-container`}>
          <form id={Classes.contactFrom} action="https://formspree.io/f/xnqrovrv" method="POST">
            <div
              className={`${Classes.gridContact} ${Classes.gridTwoColumContact}`}
             >
              <div>
                <label htmlFor="userName"></label>
                <input
                  type="text"
                  id="userName"
                  placeholder="enter your name"
                  name="userName"
                  required
                />
              </div>
              <div>
                <label htmlFor="email"></label>
                <input
                  type="email"
                  id="email"
                  placeholder="example@gmail.com"
                  name="email"
                  required
                />
              </div>
            </div>
            <div>
              <label htmlFor="subject"></label>
              <input
                type="text"
                id="subject"
                placeholder="subject"
                name="subject"
                required
              />
            </div>
            <div>
              <label htmlFor="textArea"></label>
              <textarea
                name="textArea"
                id="textArea"
                cols="30"
                rows="10"
                minLength="6"
                placeholder="write message!"
                required
              ></textarea>
            </div>
            <div>
              <label htmlFor="submit"></label>
              <input
                type="submit"
                className={Classes.btnContact}
                name="submit"
                style={{ width: "15rem" }}
                id="submit"
                value="Send Message"
              />
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
